









































import { DateRange } from '@ssp/inscreva-sse-models';
import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '../models/event';
import { EventDateHelper } from '../services/EventDateHelper';
import EventCardList from './EventCardList.vue';
import EventTimeline from './EventTimeline.vue';

@Component({
  components: {
    EventTimeline,
    EventCardList,
  },
})
export default class EventInfoCoreDetailsComponent extends Vue {
  @Prop({ required: true, type: Event })
  private event!: Event;

  get is_timeline_completed(): boolean {
    return !!(this.event.info.date.start && this.event.info.date.end);
  }

  getFormattedDate(date: string, sameDay?: boolean): string {
    return (date && moment(date).format(`${!sameDay ? 'DD/MM/YYYY ' : ''}HH:mm`)) || '';
  }

  getDate(date: DateRange): string {
    const sameDay: boolean = EventDateHelper.isSameDay(date);
    return `${this.getFormattedDate(date.start, sameDay)} - ${this.getFormattedDate(date.end, sameDay)}`;
  }
}
